module.exports = __webpack_public_path__ + "img/IMG_8938.9f3564ae.jpg";